import { render, staticRenderFns } from "./MpFinish.vue?vue&type=template&id=3a2d6428&"
import script from "./MpFinish.vue?vue&type=script&lang=js&"
export * from "./MpFinish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports